/**
 * Map API response to dropdown options including "All" on top.
 * Returns object with stations, zones, divisions, assetsType, assetsNumber
 */
export const mapRequestDataToOptions = (response) => {
    const ALL = { label: 'ALL', value: 'all' };

    return {
        stations: [
            ALL,
            ...(response?.stations || []).map((s) => ({
                label: s.name,
                value: s.station_code,
                station_code: s.station_code, // optional extra info
            })),
        ],
        zones: [
            ALL,
            ...(response?.zones || []).map((z) => ({
                label: z.zone_name,
                value: z.zone_code,
            })),
        ],
        divisions: [
            ALL,
            ...(response?.divisions || []).map((d) => ({
                label: d.division_name,
                value: d.division_code,
            })),
        ],
        assetsTypeCode: [
            ALL,
            ...Array.from(new Set((response?.master || []).map((m) => m.asset_type_code))).map((code) => {
                const m = response.master.find((item) => item.asset_type_code === code);
                return {
                    label: m.asset_type_code,
                    value: m.asset_type_code,
                    sc: m.sc,
                };
            }),
        ],
        assetsType: [
            ALL,
            ...(response?.assetType || []).map((at) => ({
                label: at,
                value: at,
            })),
        ],
        assetsNumber: [
            ALL,
            ...(response?.master || []).map((m) => ({
                label: m.asset_number_code,
                value: m.asset_type_code,
                sc: m.sc,
            })),
        ],
    };
};

export const sizePerPageList = [
    {
        text: '5',
        value: 5,
    },
    {
        text: '10',
        value: 10,
    },
    {
        text: '25',
        value: 25,
    },
    {
        text: '50',
        value: 50,
    },
];

export const alertSummaryColumns = [
    {
        Header: 'Sr Number',
        accessor: 'srNo',
    },
    {
        Header: 'Vendor Name',
        accessor: 'vcc',
    },
    {
        Header: 'Zone Code',
        accessor: 'zoneCode',
    },
    {
        Header: 'Division Code',
        accessor: 'divisionCode',
    },
    {
        Header: 'Station Code',
        accessor: 'stationCode',
    },
    {
        Header: 'Alert Type',
        accessor: 'alertType',
    },
    {
        Header: 'Asset Type',
        accessor: 'assetType',
    },
    {
        Header: 'Asset Number',
        accessor: 'assetNumber',
    },
    {
        Header: 'Cause Code',
        accessor: 'causeCode',
    },
    {
        Header: 'Total Count',
        accessor: 'totalCount',
    },
    {
        Header: 'True Count',
        accessor: 'trueCount',
    },
    {
        Header: 'Partially True Count',
        accessor: 'partiallyTrueCount',
    },
    {
        Header: '% of (True + Partially True) Alerts out of Total Alerts',
        accessor: 'resolvedPercentage',
    },
];

export const alertLiveColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Alert Type', accessor: 'alertType' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },

    { Header: 'Incidence Time', accessor: 'incidenceDate' },
    { Header: 'Rectification Time', accessor: 'rectificationDate' },
    { Header: 'Duration', accessor: 'incidenceDuration' },

    { Header: 'Cause', accessor: 'causeCode' },

    { Header: 'Feedback & Remarks', accessor: 'feedbackRemarks' },
];

export const alertDetailsColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Vendor', accessor: 'vcc' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Alert Type', accessor: 'alertType' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },
    { Header: 'Alert Status', accessor: 'alertStatus' },

    { Header: 'Cause', accessor: 'causeCode' },
    { Header: 'Feedback', accessor: 'alertFeedback' },

    { Header: 'Incidence Time', accessor: 'incidenceDate' },
    { Header: 'Rectification Time', accessor: 'rectificationDate' },
    { Header: 'Duration', accessor: 'incidenceDuration' },

    { Header: 'Maintainer', accessor: 'maintainerName' },
    { Header: 'Maintainer Designation', accessor: 'maintainerDesignation' },
    { Header: 'Maintainer Mobile', accessor: 'maintainerMobile' },

    { Header: 'Remarks', accessor: 'remarks' },
    { Header: 'Add Comments', accessor: 'action', sort: false },
];

export const maintenanceModeColumns = [
    {
        Header: 'Sr Number',
        accessor: 'srNo',
    },
    {
        Header: 'Vendor Name',
        accessor: 'vcc',
    },
    {
        Header: 'Zone Code',
        accessor: 'zoneCode',
    },
    {
        Header: 'Division Code',
        accessor: 'divisionCode',
    },
    {
        Header: 'Station Code',
        accessor: 'stationCode',
    },
    {
        Header: 'Asset Type',
        accessor: 'assetType',
    },
    {
        Header: 'Asset Number',
        accessor: 'assetNumber',
    },
    {
        Header: 'Date and Time of Maintenance mode to activate',
        accessor: 'activate',
    },
    {
        Header: 'Date and Time of Maintenance mode to clear',
        accessor: 'clear',
    },
    {
        Header: 'Maintenance Mode',
        accessor: 'maintenanceMode',
    },
];

export const TelemetryLiveColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },
    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },
    { Header: 'Parameter', accessor: 'parameter' },
];

export const TelemetryHistoryColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },
    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },
    { Header: 'Parameter', accessor: 'parameter' },
];

export const rdpmshealthDetailsColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Total Sensors', accessor: 'totalSensors' },
    { Header: 'Faulty Sensors', accessor: 'faultySensors' },
    { Header: 'Total IoTs', accessor: 'totalIoTs' },

    { Header: 'Faulty IoTs', accessor: 'faultyIoTs' },
    { Header: 'Total Network', accessor: 'totalNetwork' },
    { Header: 'Faulty Network', accessor: 'faultyNetwork' },

    { Header: 'Total Station gateway', accessor: 'totalStationGateway' },
    { Header: 'Faulty Station gatway', accessor: 'faultyStationGatway' },
];

export const rdpmshealthLiveColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },

    { Header: 'Faulty Sensor description', accessor: 'faultySensorDescription' },
    { Header: 'Faulty IoT description', accessor: 'faultyIotDescription' },
    { Header: 'Faulty Network description', accessor: 'faultyNetworkDescription' },

    { Header: 'Faulty Station gateway', accessor: 'faultyStationGateway' },
];

export const rdpmshealthSummaryColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },

    { Header: 'Total Number Of Sensors', accessor: 'totalNumberOfSensors' },
    { Header: '% Availability of Sensors', accessor: 'availabilityOfSensors' },
    { Header: 'Total Number Of IoTs', accessor: 'totalNumberOfIoTs' },

    { Header: '% Availability Of IoTs', accessor: 'availabilityOfIoTs' },

    { Header: 'Total Number Of Network', accessor: 'totalNumberOfNetwork' },
    { Header: '% Availability of Network', accessor: 'availabilityOfNetwork' },
    { Header: 'Total Number Of Station Gateway', accessor: 'totalNumberOfStationGateway' },
    { Header: '% Availability of station gateway', accessor: 'availabilityOfStationGateway' },
];

export const equipmentRoomLiveColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Equipment Room Type', accessor: 'equipmentRoomType' },
    { Header: 'Temperature', accessor: 'temperature' },

    { Header: 'Humidity', accessor: 'humidity' },
    { Header: 'Relay Room opening (Open/Close)', accessor: 'relayRoomOpening' },
];

export const equipmentRoomHistoryColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Date & Time', accessor: 'dateTime' },
    { Header: 'Equipment Room Type', accessor: 'equipmentRoomType' },

    { Header: 'Temperature', accessor: 'temperature' },
    { Header: 'Humidity', accessor: 'humidity' },
    { Header: 'Relay Room opening (Open/Close)', accessor: 'relayRoomOpening' },
];

export const assetUtilizationColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },
    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },

    { Header: 'Number of operations', accessor: 'numberOfOperations' },
];

export const assetsColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Vendor Code', accessor: 'vcc' },
    { Header: 'Vendor Name', accessor: 'vcn' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Make', accessor: 'assetMake' },

    { Header: 'Total Count', accessor: 'totalCount' },
];

export const performanceColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    {
        Header: '% of (True + Partially True) Failure Alerts out of total Failure Alerts generated',
        accessor: 'failure',
    },
    {
        Header: '% of (True + Partially True) Predictive Alerts out of total Predictive Alerts generated',
        accessor: 'predective',
    },
    {
        Header: '% of (True + Partially True) Failure Alerts by RDPMS out of total actual failures occurred at station',
        accessor: 'actualAlert',
    },
];
